<template>
  <div class="tag-new-ideas">
    <p>{{title}}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.tag-new-ideas {
  background: theme.$accent-color-light;
  border-radius: theme.$button-border-radius;
  text-align: center;
  max-width: 100px;
  padding: 3px 4px;
  color: theme.$accent-color;
  height: 24px;
}

.tag-new-ideas p {
  margin: auto;
  font-weight: 600;
  font-size: 12px;
}
</style>